import { useStore } from '../../lib/hooks/useStore';
import { AppIconType } from '../../lib/typegen/app-icon-type';
import GenericButton from '../button-generic';
import CurrencyValue from '../currency-value';
import style from './style.module.scss';

export interface ListOptionItem extends React.ButtonHTMLAttributes<HTMLLIElement> {
	id: string;
	icon?: AppIconType;
	linkTarget?: string;
	label: string;
	isEnabled?: boolean;
	value?: string | number;
	callback?: (id: string) => void;
}

interface ListOptionsProps extends React.ButtonHTMLAttributes<HTMLUListElement> {
	options: ListOptionItem[];
	separator?: string;
	useSeparator?: boolean;
	currencySymbol?: string;
	useCurrencySymbol?: boolean;
}

export default function ListOptions({
	options,
	className,
	separator = ':',
	useSeparator,
	useCurrencySymbol,
	currencySymbol = '$',
}: ListOptionsProps) {
	const {
		uiStore: { handleNavigation },
		configStore: { getString },
	} = useStore();
	return (
		<ul className={[style.items, className].join(' ')} role='listbox'>
			{options.map(({ id, linkTarget, isEnabled, label, className, value, callback }, i) => {
				const styles = [style.items__item, style.item, className];

				if (!isEnabled) styles.push(style['item--disabled']);

				return (
					<GenericButton
						key={i}
						role='option'
						tabIndex={0}
						className={style.items__button}
						onClick={() => {
							if (callback) callback(id);
							if (linkTarget) handleNavigation(linkTarget);
						}}
						innerHtml={
							<>
								<span className={style.item__label}>
									{getString(label)}
									{useSeparator && value ? separator : ''}
								</span>
								{value && (
									<span className={''}>
										{typeof value === 'number' ? (
											<CurrencyValue value={value} useCurrencySymbol={useCurrencySymbol} currencySymbol={currencySymbol} />
										) : (
											value
										)}
									</span>
								)}
							</>
						}
					/>
				);
			})}
		</ul>
	);
}
